import React from 'react';
import PropTypes from 'prop-types';
import { getFileTags } from 'utils/custom';
import useMediaTagsAccess from './useMediaTagsAccess';
import * as Styled from './FileTagList.styles';

/**
 * Read-only chips for the tags a visit's file field carries (visit view / edit pages).
 *
 * Looks like the gallery's TagChips and shares its palette (mango = custom tag, forest = form-linked),
 * but has no add/remove: the visit payload gives the tag names only, not the media id that the
 * assign/unassign endpoints need — tags are still managed from the Media gallery. Renders nothing when
 * the file has no tags, so it can be dropped under any file question.
 */
const FileTagList = ({ value, formOnly, className }) => {
  const canUseTags = useMediaTagsAccess();
  // `formOnly` is for surfaces that edit the custom tags themselves (the visit edit form) and only
  // need the system-managed ones rendered alongside.
  const tags = getFileTags(value).filter((tag) => !formOnly || tag.formLinked);
  if (!canUseTags || !tags.length) return null;

  return (
    <Styled.TagRow className={className}>
      {tags.map(({ id, name, formLinked }) => (
        <Styled.Chip key={id ?? name} formLinked={formLinked}>
          <span title={name}>{name}</span>
        </Styled.Chip>
      ))}
    </Styled.TagRow>
  );
};

FileTagList.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  // Render only the form-linked (system-managed) tags.
  formOnly: PropTypes.bool,
  className: PropTypes.string,
};

FileTagList.defaultProps = {
  value: null,
  formOnly: false,
  className: '',
};

export default FileTagList;
